let width = document.body.clientWidth;
if (document.querySelectorAll('.home-slider').length > 0) {

    let sliders = document.querySelectorAll('.slider-glide.home-slide');
    for (const slider of sliders) {
        // Dupliquer les slides pour créer un effet infini
        const slidesContainer = slider.querySelector('.glide__slides');
        const slides = slidesContainer.children;
        const slidesArray = Array.from(slides);

        // Cloner les slides pour le mode infini
        slidesArray.forEach(slide => {
            const clone = slide.cloneNode(true);
            slidesContainer.appendChild(clone);
        });

        let glideSlider = new Glide(slider, {
            type: 'carousel',
            perView: slider.dataset.nbslidexxl ? slider.dataset.nbslidexxl : "1",
            autoplay: true,
            hoverpause: true,
            animationDuration: 3000,
            gap: 30,
            rewind: false,
            breakpoints: {
                1399: {
                    perView: slider.dataset.nbslidexl
                },
                1199: {
                    perView: slider.dataset.nbslidelg
                },
                991: {
                    perView: slider.dataset.nbslidemd,
                    gap: 20
                },
                767: {
                    perView: slider.dataset.nbslide,
                    gap: 10
                }
            }
        });

        glideSlider.mount();
    }
}


document.addEventListener('DOMContentLoaded', function () {
    let lightGalleries = document.querySelectorAll('.lightgallery-carousel');
    if (lightGalleries.length > 0) {
        for (const gallery of lightGalleries) {
            let thisGallery = lightGallery(gallery, {
                counter: true,
                download: false,
                mode: 'lg-slide',
                cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
                subHtmlSelectorRelative: true,
                getCaptionFromTitleOrAlt: gallery.dataset.class == "hideCaption" ? false : true
            });

            if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
                document.querySelector(gallery.dataset.trigger).addEventListener('click', (e) => {
                    e.preventDefault();
                    gallery.firstElementChild.click();
                });
            }
        }
    }

    let lightGalleriesSimple = document.querySelectorAll('.lightgallery');
    if (lightGalleriesSimple.length > 0) {
        for (const gallery of lightGalleriesSimple) {
            let thisGallery = lightGallery(gallery, {
                plugins: [lgVideo, lgThumbnail, lgZoom],
                counter: true,
                download: false,
                mode: 'lg-slide',
                cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
                subHtmlSelectorRelative: true,
                preload: 1,
                thumbnail: gallery.dataset.thumbnail === "show",
                getCaptionFromTitleOrAlt: gallery.dataset.class !== "hideCaption",
                youTubePlayerParams: {
                    modestbranding: 1,
                    showinfo: 0,
                    controls: 1,
                    rel: 0
                }
            });

            if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
                let allImagesBtn = document.querySelectorAll(gallery.dataset.trigger);
                for (const imageBtn of allImagesBtn) {
                    imageBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (imageBtn.dataset.imgcount) {
                            gallery.getElementsByTagName('a')[imageBtn.dataset.imgcount].click();
                        } else {
                            gallery.firstElementChild.click();
                        }
                    });
                }
            }
        }
    }
});